import { Component, OnInit } from "@angular/core";
import * as moment from "moment";

import { GatewayView } from "../../gateway-view";
import { SpinnerOverlayRef } from "../../../../common/spinner/spinner-overlay.ref";
import { SpinnerOverlayService } from "../../../../common/spinner/spinner-overlay.service";
import { TranslateService } from "../../../../common/translate";
import { SnackbarService } from "../../../../common/snackbar/snackbar.service";
import { ApiGatewayService } from "../../../../common/api-gateway/api-gateway.service";
import { GatewaysService } from "../../gateways.service";

@Component({
	selector: "sdp-gateway-pending-accept",
	templateUrl: "./pending-accept.component.html"
})
export class PendingAcceptComponent implements OnInit {

	public gateway!: GatewayView;
	private timer: NodeJS.Timer | undefined;
	public isGatewayDead = false;
	public readonly warningIcon = { type: "material", name: "warning", cssClass: "sdp-icon-button-icon sdp-gatway-pending-icon" };
	private readonly errorWaitTime = moment.duration(15, "minutes");

	constructor(
		public gatewayService: GatewaysService,
		public apiService: ApiGatewayService,
		public translateService: TranslateService,
		public snackbarService: SnackbarService,
		public overlay: SpinnerOverlayService) {
	}

	public ngOnInit() {
		if (this.gateway.state === "pending") {
			return;
		}
		// if already dead dont do anything
		if (!isDeadGateway(this.gateway, this.errorWaitTime)) {
			this.timer = setInterval(async () => {
				if (this.gateway.state === "pending") {
					if (!!this.timer) {
						clearInterval(this.timer);
					}
				} else {
					this.gateway = await this.apiService.getGateway(this.gateway.uuid);
				}
				if (isDeadGateway(this.gateway, this.errorWaitTime)) {
					if (!!this.timer) {
						clearInterval(this.timer);
					}
					this.isGatewayDead = true;
					return;
				}
			}, 5000);
		} else {
			this.isGatewayDead = true;
		}
	}

	public get isProvisioning() {
		if (!!this.gateway) {
			return this.gateway.state === "provisioning";
		} else {
			return false;
		}
	}

	public accept() {
		return new Promise<boolean>(async (resolve, reject) => {
			let ref: SpinnerOverlayRef | undefined = undefined;
			try {
				ref = this.overlay.open();
				await this.gatewayService.acceptPendingGateway(this.gateway.uuid);
				this.snackbarService.open(this.translateService.translate("sdp.gateway.accept.success", { label: this.gateway.label }));
				resolve(true);
			} catch (e) {
				this.snackbarService.showErrorBar(e, { label: this.gateway.label });
				reject(e);
			} finally {
				if (!!ref) {
					ref.close();
				}
			}
		});
	}

}

function isDeadGateway(gateway: GatewayView, waitTime: moment.Duration) {
	return moment().isAfter(moment(gateway.registrationDate).add(waitTime)) && gateway.state === "provisioning";
}
